export default {
  name: 'TermoContingencial',
  path: '/TermoContingencial',
  component: () => import('modules/term/term.vue'),
  meta: {
    breadcrumbs: [
      {
        text: 'Novo Smart',
        name: 'Dashboard'
      },
      {
        text: 'Termo Contingencial',
        name: 'TermoContingencial'
      }
    ]
  }
};
